module.exports = __webpack_public_path__ + "img/img_13.44ae3419.png";